// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-layout[data-v-72bde94c]{display:grid;grid-template-columns:repeat(12,1fr);min-height:500px}.full-layout-content[data-v-72bde94c]{grid-column:span 12;position:relative}", ""]);
// Exports
module.exports = exports;
